module.exports = __webpack_public_path__ + "media/bg.38cd79d9.webm";